import { Link } from 'react-router-dom'
import { Rocket, Book, GraduationCap, Video } from 'lucide-react'
import './Home.css'

const Home = () => {
  const features = [
    {
      icon: <Rocket size={24} />,
      title: 'Getting Started',
      description: 'Learn how to install and configure the Variable Modding System with our step-by-step guides.',
      link: '/plugins/VariableModding/getting-started'
    },
    {
      icon: <Book size={24} />,
      title: 'Core Concepts',
      description: 'Understand the fundamental concepts behind CSV generation and variable management.',
      link: '/plugins/VariableModding/core-concepts'
    },
    {
      icon: <GraduationCap size={24} />,
      title: 'Advanced Documentation',
      description: 'Deep dive into advanced features, API reference, and best practices for power users.',
      link: '/plugins/VariableModding/advanced'
    },
    {
      icon: <Video size={24} />,
      title: 'Video Tutorials',
      description: 'Watch comprehensive video tutorials to master the Variable Modding System quickly.',
      link: '/plugins/VariableModding/video-tutorials'
    }
  ]

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-name">Variable Modding System</span>
          </h1>
          <p className="hero-tagline">Powerful plugin for variable management</p>
          <p className="hero-description">
            A comprehensive system for creating and managing dynamic variables in your server
          </p>
        </div>
      </section>

      <section className="features">
        <div className="features-grid">
          {features.map((feature, index) => (
            <Link key={index} to={feature.link} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Home
